import { useState } from 'react';
import {
    Grid,
    Button,
    Divider
} from '@mui/material';
import { useSelector } from 'react-redux';
import CbBatchData from './production/CbBatchData';
import CbBatchMedia from './production/CbBatchMedia';
import CbPileVariability from './production/CbPileVariability';

export default function CbProduction() {
    const [selectedCategory, setSelectedCategory] = useState('Batch Data');
    const { selectedProject } = useSelector(state => state.postFormData);
    const { id, measureType } = selectedProject || {}

    const CB_PRODUCTION_CATEGORIES = [
        'Batch Data',
        'Pile Variability',
        'Batch Media',
    ];

    return (
        <Grid container>
            <Grid item xs={12} sx={{ display: 'flex', pb: 3, gap: 2 }}>
                {CB_PRODUCTION_CATEGORIES.map((productionCategory, index) => (
                    <Button
                        key={index}
                        onClick={() => setSelectedCategory(productionCategory)}
                        variant={selectedCategory === productionCategory ? 'contained' : 'outlined'}
                        disabled={productionCategory === 'Pile Variability'}
                    >
                        {productionCategory}
                    </Button>
                ))}
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12} sx={{ p: 2 }}>
                {
                    selectedCategory === 'Batch Data' &&
                    <CbBatchData projectKey={id} measureType={measureType} />
                }
                {
                    selectedCategory === 'Pile Variability' &&
                    <CbPileVariability projectKey={id} measureType={measureType} />
                }
                {
                    selectedCategory === 'Batch Media' &&
                    <CbBatchMedia projectKey={id} />
                }
            </Grid>
        </Grid>
    );

}


